import { toValue } from '@vueuse/shared';
import { MaybeRefOrGetter } from '@vueuse/shared';
import { isClient } from "~/utils/helpers";

import { ref, onMounted, watchEffect } from "@nuxtjs/composition-api";
// import { useMounted } from "@vueuse/core";

type ScrollElement = HTMLElement | Window;

const overflowScrollReg = /scroll|auto|overlay/i;
const defaultRoot = isClient() ? window : undefined;

function isElement(node: Element) {
  const ELEMENT_NODE_TYPE = 1;
  return (
    node.tagName !== 'HTML' &&
    node.tagName !== 'BODY' &&
    node.nodeType === ELEMENT_NODE_TYPE
  );
}

// https://github.com/vant-ui/vant/issues/3823
export function getScrollParent(
  el: Element,
  root: ScrollElement | undefined = defaultRoot,
) {
  let node = el;

  while (node && node !== root && isElement(node)) {
    const { overflowY } = window.getComputedStyle(node);
    if (overflowScrollReg.test(overflowY)) {
      return node;
    }
    node = node.parentNode as Element;
  }

  return root;
}

export function useScrollParent(
  el: MaybeRefOrGetter<Element| undefined>,
  root: ScrollElement | undefined = defaultRoot,
) {
  const scrollParent = ref<Element | Window>();

  onMounted(() => {
    let ele = toValue(el)
    if (ele) {
      scrollParent.value = getScrollParent(ele, root);
    }
  });

  return scrollParent;
}
